import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import UserActions from "../../store/user/Actions";
import { connect } from "react-redux";
//import "../App/App.css";
//css files
import "../App/App.scss";
import "../../css/bootstrap.css";
import "./KnovoActivityScreen.css";
import "../CommonItems/ActivityHeader.css";
import "../CommonItems/CommonStyle.css";
import "../CommonItems/ComponentsStyles.css";
import "../CommonItems/HamburgerMenuStyle.css";
import "../CommonItems/ComponentsStyles.css";
import "../CommonItems/AiAssistance.css";
//Smart Tile css
import "../SmartTileScreen/SmartTile.css";
//Smart Slide css
import "../SmartSlideScreen/SmartSlideScreen.css";
//Smart label css
import "../SmartLabelScreen/SmartLabelStyles.css";
import "../CommonItems/ActivityFooter.css";
//Smart paper css
import "../SmartPaperScreen/SmartPaperScreen.css";
//Smart canvas css
import "../SmartCanvasScreen/SmartCanvasScreen.css";
import "../SmartCanvasScreen/TemplatesStyle.css";
import "../../css/SmartCanvasCss/KnovaComponents.css";
import "../../css/SmartCanvasCss/KnovaPalette.css";
import "../../css/SmartCanvasCss/TemplateSideNav.css";
import "../../css/SmartCanvasCss/DrawingCanvas.css";

import "katex/dist/katex.min.css";

import Images from "../../images";
import {
  Tutor,
  ConfirmPopup,
  TeacherFeedback,
  ActivityHeader,
  ActivityMenu,
  SmartCanvasBaseScreen,
  studentDataToApi,
  SmartPaperParentScreen,
  SmartTileMainScreen,
  SmartSlideMainScreen,
  SmartLabelParentScreen,
} from "root-components";
import {
  getTimeSpent,
  getTimeSpentOverall,
  getSubmitDate,
} from "../../utils/TimerUtils";
import {
  EXCERCISE_SAVED,
  DONE_CONFIRMATION,
  RESET_CONFIRMATION,
  RECORD_CONFIRMATION,
  RECORD_DELETE,
  RECORD_ONGOING,
  SMART_PAPER,
  SMART_SLIDE,
  SMART_LABEL,
  SMART_TILE,
  GET_ACTIVITY,
} from "../../constants";
import ToastBox from "../ToastBox/ToastBox";
import SmartSlideScreen from "../SmartSlideScreen/SmartSlideScreen";
import SmartPaperScreen from "../SmartPaperScreen/SmartPaperScreen";
import Loader from "../../components/Loader/Loader";
import knovoEntrence from "../../animations/Knovo_Entrance.json";
import knovoTalk from "../../animations/Knovo_Talk.json";
import knovoIdle from "../../animations/Knovo_Idle.json";
import knovoExit from "../../animations/Knovo_Exit.json";
import knovoPositive from "../../animations/Knovo_Positive.json";
import knovoNegative from "../../animations/Knovo_Negative.json";
import Lottie from "react-lottie";

import WalkThroughIntro from "../CommonItems/WalkThroughIntro";

function KnovoActivityScreen(props) {
  const history = useHistory();
  const { isContained, closeContained, containedActivity } = props; //for Contained
  const {
    user,
    token,
    currentActivity,
    currentLessonUnitDistId,
    exerciseList,
    currentCourseId,
    lessonUnitDetails,
    previousExerciseList,
    fromAnalytics,
    fromCourse,
    unitName,
    loading,
    currentOSName,
    walkthroughStatus,
    muteClicked,
    muteStatus,
    // speechApi,
  } = props; // from redux state
  const {
    setHeaderTitle,
    saveActivityForStudent,
    refreshToken,
    userToken,
    setExerciseList,
    getActivityForStudent,
    setPreviousExerciseList,
    getLessonUnitDetailsForStudent,
    setShowHideLoader,
    showOrHideToaster,
    hardResetRandomActivity,
    saveWalkthroughStatus,
    onHeaderItemSelected,
    setNavigationIndex,
    saveMuteStatus,
    chatChallengeMe,
  } = props; //from dispatch
  const {
    ActivityJson,
    AppName,
    ContentMode,
    Completed,
    ContentID,
    ActivityType,
    ContentName,
    Feedback,
    Status,
    FollowTheFlow,
    AutoHint,
    WorkJson,
    OtherActivities,
    IsCanvas,
  } = isContained ? containedActivity : currentActivity;

  const isPractice = ActivityType === "practice" ? true : false;
  let msg = new SpeechSynthesisUtterance();
  // Check Answer variables
  const [currentDisplayMode, setcurrentDisplayMode] = useState("normal");
  const isVerifyMode = currentDisplayMode === "verify";
  // Answer Explanation
  const [explanationClick, setExplanationClick] = useState(false);
  const [explanationText, setExplanationText] = useState("");
  const [explanationStatus, setExplanationStatus] = useState(false);
  const [explanationVisible, setExplanationVisible] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  //Teacher feedback variables
  const [feedbackVisible, setFeedbackVisible] = useState(false);

  const [getAttempts, setGetAttempts] = useState(0);
  const [getAttemptsPractice, setGetAttemptsPractice] = useState(0);
  const [getCoordinateArray, setGetCoordinateArray] = useState([]);

  const [getCumulativeAverageScoreOld, setGetCumulativeAverageScoreOld] =
    useState(0);
  const [getResetDataValue, setGetResetDataValue] = useState(0);

  //Header variables
  const [initial, setInitial] = useState(true);
  const [disableClick, setDisableClick] = useState(true);
  //Timer variables
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [secondsPractice, setSecondsPractice] = useState(0);
  const [minutesPractice, setMinutesPractice] = useState(0);
  //Hamburger menu variables
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  //score variables
  const [getActivityCurrentScore, setGetActivityCurrentScore] = useState(0);
  const [activityTotalScore, setActivityTotalScore] = useState(0);
  const [getCurrentScoreApi, setGetCurrentScoreApi] = useState(0);
  const [getCurrentScoreReset, setGetCurrentScoreReset] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [screenName, setScreenName] = useState("");
  const [modesWorkData, setModesWorkData] = useState([]);

  const [activityJson, setActivityJson] = useState({});
  const [currentActivityWorkJson, setCurrentActivityWorkJson] = useState("");
  //Tutor variables
  const [ttsData, setTtsData] = useState([]);
  const [tutorialStart, setTutorialStart] = useState(false);
  const [isSubtitle, setIsSubtitle] = useState(true);
  const [isBgAudioPlayed, setIsBgAudioPlayed] = useState(false);

  const [activitySaveClick, setActivitySaveClick] = useState(false);
  const [activitySaveType, setActivitySaveType] = useState("SAVE");
  const activityNavigationType = useRef();
  const arrowNavigationType = useRef();
  const sideMenuItemSelected = useRef();
  //Reset variables
  const [popupType, setPopupType] = useState("");
  const [confirmPopupVisible, setConfirmPopupVisible] = useState(false);
  const [activityResetType, setActivityResetType] = useState("");
  const [isReset, setIsReset] = useState(false);

  const [currentActiveSlide, setCurrentActiveSlide] = useState("");
  const [recordPopupClick, setRecordPopupClick] = useState(-1);

  const [isHardReset, setIsHardReset] = useState(false);

  //animated variables
  const [displayHeader, setDisplayHeader] = useState(false);
  const [displayKnovoEntrence, setDisplayKnovoEntrence] = useState(false);
  const [displayKnovoTalk, setDisplayKnovoTalk] = useState(false);
  const [displayKnovoExit, setDisplayKnovoExit] = useState(false);
  const [tutorTalking, setTutorTalking] = useState(true);
  const [validationFeedback, setValidationFeedback] = useState("");
  const [isFeedbackAnime, setIsFeedbackAnime] = useState(false);

  const ansContainerRef = useRef();
  const [canvasAreaDimensions, setCanvasAreaDimensions] = useState({
    width: 0,
    height: 0,
  });

  const headerContainerRef = useRef();
  const [headerAreaDimensions, setHeaderAreaDimensions] = useState({
    width: 0,
    height: 0,
  });

  //walkthroug variables
  const [displayWalkThrough, setDisplayWalkThrough] = useState(false);
  const [currentWalkThroughStep, setCurrentWalkThroughStep] = useState(-1);
  const [isKnovoHelpOpen, setIsKnovoHelpOpen] = useState(false);
  const [walkThroughManual, setWalkThroughManual] = useState(false);

  const [isWarningBotTalking, setIsWarningBotTalking] = useState(false);
  const [hideHeaderValue, sethideHeaderValue] = useState(false);

  const [recordingStatus, setIsRecordingStatus] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isContainedOpen, setIsContainedOpen] = useState(false);
  const [isExpandableView, setIsExpandableView] = useState(false);

  const [resize, setResize] = useState(0);

  const [isGuidedActivity, setIsGuidedActivity] = useState(false);

  const [newlyOpenedActivity, setNewlyOpenedActivity] = useState(false);

  //Template fullscreen variables
  const [isMinimize, setIsMinimize] = useState(true);
  const [currentActivePage, setCurrentActivePage] = useState(0);

  //AI chat response variables
  const [aiChatResponseData, setAiChatResponseData] = useState({});

  //Replay strokes variables
  const [isReplaying, setIsReplaying] = useState(false);

  const [isExtraPracticeVisible, setIsExtraPracticeVisible] = useState(false);

  //Handle browser back icon
  const onBackButtonEvent = (event) => {
    event.preventDefault();
  };

  //Call when browser is resizing
  useEffect(() => {
    const resizeListener = () => {
      setResize((resize) => resize + 1);
    };

    // set resize listener
    window.addEventListener("resize", resizeListener);

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
      window.removeEventListener("resize", resizeListener);
    };
  }, []);
  //End of browser resize functions
  // const [speechApi, setSpeechApi] = useState();
  // useEffect(() => {
  //   var u = new SpeechSynthesisUtterance();
  //   //u.text = 'Hello World';
  //   u.lang = "en-US";
  //   u.rate = 1;
  //   u.pitch = 0.4;
  //   //speechSynthesis.speak(u);
  //   console.log("speechSynthesisData", u);
  //   setSpeechApi(u);
  // }, []);

  const [saveUserErrorCount, setSaveUserErrorCount] = useState(0);
  const [selectedContentID, setSelectedContentID] = useState(0);

  useEffect(() => {
    let interval = null;
    if (isActive && Completed === 0) {
      interval = setInterval(() => {
        if (seconds > 59) {
          setSeconds(0);
          setMinutes((minutes) => minutes + 1);
        } else {
          setSeconds((seconds) => seconds + 1);
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  useEffect(() => {
    let interval = null;
    if (isActive && Completed === 0) {
      interval = setInterval(() => {
        if (secondsPractice > 59) {
          setSecondsPractice(0);
          setMinutesPractice((minutes) => minutes + 1);
        } else {
          setSecondsPractice((seconds) => seconds + 1);
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isActive, secondsPractice]);

  function checkWalkthroughStatus() {
    if (walkthroughStatus) {
      startActivity();
    } else {
      setDisplayWalkThrough(true);
      setDisplayKnovoEntrence(false);
      setDisplayKnovoTalk(true);
    }
  }

  //Get activity data
  useEffect(() => {
    // setHeaderTitle("Smart paper");
    if (ActivityJson) {
      setIsActive(true);
      setDisplayHeader(true);
      setIsBgAudioPlayed(false);
      const exercise = JSON.parse(ActivityJson);
      setActivityJson(exercise);
      // if (AppName !== SMART_SLIDE) {
      setTtsData([]);
      setTimeout(() => {
        if (initial) {
          setDisplayKnovoEntrence(true);
        }
      }, 1000);
      if (initial) {
        setTimeout(() => {
          setInitial(false);
          if (AppName === SMART_PAPER) {
            checkWalkthroughStatus();
          } else {
            startActivity();
          }
        }, 3200);
      } else {
        if (AppName === SMART_PAPER) {
          checkWalkthroughStatus();
        } else {
          startActivity();
        }
      }
      // }
      if (AppName === SMART_PAPER) {
        setHeaderTitle("SmartPaper");
        setActivityTotalScore(exercise.TotalScore);
        calculateTotalScoreForTheActivity(exercise);
      } else if (AppName === SMART_TILE) {
        setHeaderTitle("SmartTiles");
        setActivityTotalScore(exercise.TotalScore);
      } else if (AppName === SMART_SLIDE) {
        setHeaderTitle("SmartSlide");
        setActivityTotalScore(exercise.TotalScore);
      } else if (AppName === SMART_LABEL) {
        setHeaderTitle("SmartLabel");
        setActivityTotalScore(exercise.TotalWeight);
      }
      setShowHideLoader(false);
      console.log("parentCurrentActivity", currentActivity);
      console.log("ParentActivityJson", exercise);

      //set workjson timer value
      if (WorkJson && WorkJson !== "" && WorkJson !== "[]") {
        let workJson = {};
        if (AppName === SMART_LABEL) {
          workJson = JSON.parse(WorkJson)[0];
        } else {
          workJson = JSON.parse(WorkJson)[0];
        }
        setMinutes(
          parseInt(
            workJson.TimeTakenOverall
              ? workJson.TimeTakenOverall.split(":")[0]
              : 0
          )
        );
        setSeconds(
          parseInt(
            workJson.TimeTakenOverall
              ? workJson.TimeTakenOverall.split(":")[1]
              : 0
          )
        );
        setMinutesPractice(
          parseInt(workJson.TimeTaken ? workJson.TimeTaken.split(":")[0] : 0)
        );
        setSecondsPractice(
          parseInt(workJson.TimeTaken ? workJson.TimeTaken.split(":")[1] : 0)
        );
      } else {
        setMinutes(0);
        setSeconds(0);
        setMinutesPractice(0);
        setSecondsPractice(0);
      }
    }
  }, [currentActivity]);

  function calculateTotalScoreForTheActivity(exercise) {
    let activityTotalScore = 0;
    if (OtherActivities && OtherActivities.length > 0) {
      let allActivityScore = 0;
      OtherActivities.map((activityData) => {
        allActivityScore =
          JSON.parse(activityData.ActivityJson).TotalScore + allActivityScore;
      });
      activityTotalScore = allActivityScore;
    } else {
      activityTotalScore = exercise.TotalScore;
    }
    setActivityTotalScore(activityTotalScore);
  }

  useEffect(() => {
    if (AppName === SMART_LABEL) {
      setSmartLabelTimer();
    }
  }, [modesWorkData]);

  function setSmartLabelTimer() {
    if (screenName !== "Answer") {
      let indexOfShuffle = -1;
      indexOfShuffle = modesWorkData.findIndex(
        (obj) => obj.ContentID === ContentID && obj.ModeName === screenName
      );
      if (indexOfShuffle >= 0) {
        const workJson = modesWorkData[indexOfShuffle];
        setMinutes(
          parseInt(
            workJson.TimeTakenOverall
              ? workJson.TimeTakenOverall.split(":")[0]
              : 0
          )
        );
        setSeconds(
          parseInt(
            workJson.TimeTakenOverall
              ? workJson.TimeTakenOverall.split(":")[1]
              : 0
          )
        );
        setMinutesPractice(
          parseInt(workJson.TimeTaken ? workJson.TimeTaken.split(":")[0] : 0)
        );
        setSecondsPractice(
          parseInt(workJson.TimeTaken ? workJson.TimeTaken.split(":")[1] : 0)
        );
      } else {
        setMinutes(0);
        setSeconds(0);
        setMinutesPractice(0);
        setSecondsPractice(0);
      }
    }
  }

  // useEffect(() => {
  //   if (AppName === SMART_SLIDE) {
  //     if (currentActiveSlide !== "") {
  //       setIsBgAudioPlayed(false);
  //       setTtsData([]);
  //       checkTutorInstructions(currentActiveSlide);
  //     }
  //   }
  // }, [currentActiveSlide]);

  function startActivity() {
    const exercise = JSON.parse(ActivityJson);
    // buttonRef.current.click();
    if (AppName === SMART_PAPER || AppName === SMART_TILE) {
      saveWalkthroughStatus(true);
    }
    setDisplayWalkThrough(false);
    setCurrentWalkThroughStep(-1);
    if (walkThroughManual) {
      setWalkThroughManual(false);
    } else {
      checkTutorInstructions(exercise);
      setDisplayKnovoEntrence(false);
    }
  }

  //check tutor message is available and play
  function checkTutorInstructions(exercise) {
    if (
      AppName === SMART_PAPER ||
      AppName === SMART_TILE ||
      AppName === SMART_SLIDE ||
      AppName === SMART_LABEL
    ) {
      // setDisplayKnovoTalk(true);
      setIsBgAudioPlayed(true);
    }
  }

  //check tutor message is available and play
  // function checkTutorInstructions(exercise) {
  //   setDisplayKnovoTalk(true);
  //   if (AppName !== SMART_SLIDE) {
  //     //  if (AppName === SMART_PAPER && IsCanvas) {
  //     if (
  //       AppName === SMART_PAPER ||
  //       AppName === SMART_TILE ||
  //       AppName === SMART_SLIDE ||
  //       AppName === SMART_LABEL
  //     ) {
  //       setTtsData([""]);
  //     } else {
  //       if (Status === "Pending") {
  //         if (exercise.TextToSpeech) {
  //           let activityInitialInstruction = exercise.TextToSpeech;
  //           if (
  //             activityInitialInstruction &&
  //             activityInitialInstruction &&
  //             activityInitialInstruction.length !== 0 &&
  //             activityInitialInstruction[0] !== ""
  //           ) {
  //             setTtsData(activityInitialInstruction[0]);
  //           } else {
  //             setTtsData([""]);
  //           }
  //         } else {
  //           setTtsData([""]);
  //         }
  //       } else if (Status === "Completed") {
  //         setTtsData([""]);
  //       } else {
  //         setTtsData([
  //           "Welcome back to the activity! Let's pick things up from where we left off.",
  //         ]);
  //       }
  //     }
  //   } else {
  //     setTtsData([""]);
  //     // if (exercise.TextToSpeech) {
  //     //   let activityInitialInstruction = exercise.TextToSpeech;
  //     //   if (
  //     //     activityInitialInstruction &&
  //     //     activityInitialInstruction &&
  //     //     activityInitialInstruction.length !== 0 &&
  //     //     activityInitialInstruction[0] !== ""
  //     //   ) {
  //     //     setTtsData(activityInitialInstruction[0]);
  //     //   } else {
  //     //     setTtsData([""]);
  //     //   }
  //     // } else {
  //     //   setTtsData([""]);
  //     // }
  //   }
  // }

  useEffect(() => {
    if (ttsData.length > 0) {
      if (newlyOpenedActivity) {
      } else {
        setTutorialStart(true);
      }
    }
  }, [ttsData, newlyOpenedActivity]);

  useEffect(() => {
    if (!tutorTalking) {
      setDisplayKnovoTalk(true);
    }
  }, [tutorTalking]);

  function saveDataAndNavigate(
    studentDataFromActivity,
    navType,
    previous,
    index,
    isRecord,
    tokenData
  ) {
    if (Completed === 0 && isActive) {
      saveActivityForStudent(tokenData, studentDataFromActivity, (response) => {
        if (response.Success) {
          afterSaveResponse(index, isRecord, navType, previous);
        } else {
          if (saveUserErrorCount < 1) {
            if (response.StatusCode === 401) {
              refreshToken(tokenData, (tokenResponse) => {
                if (tokenResponse.Success) {
                  userToken(tokenResponse.Token);
                  saveDataAndNavigate(
                    studentDataFromActivity,
                    navType,
                    previous,
                    index,
                    isRecord,
                    tokenResponse.Token
                  );
                  setSaveUserErrorCount(1);
                } else {
                  setShowHideLoader(false);
                  showOrHideToaster(
                    true,
                    "Server failed! Please try again.",
                    "error"
                  );
                  setSaveUserErrorCount(0);
                  setActivitySaveClick(false);
                }
              });
            }
          } else {
            setShowHideLoader(false);
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setActivitySaveClick(false);
          }
        }
      });
    } else {
      if (isContained) {
        closeContained(true);
        setShowHideLoader(false);
      } else {
        if (navType === "arrow") {
          if (previous) {
            checkAndNavigatePrevious(previous);
          } else {
            if (exerciseList.length > 0) {
              checkAndNavigatePrevious(previous);
            } else {
              setShowHideLoader(false);
              showOrHideToaster(true, "You are in last activity", "warning");
            }
          }
        } else if (navType === "sideMenu") {
          checkAndNavigate(index);
        } else if (navType === "submit") {
          setShowHideLoader(false);
        } else if (navType === "close") {
          if (fromAnalytics) {
            history.push("/detailactivityreport");
          } else {
            if (isContained) {
              setShowHideLoader(false);
              showOrHideToaster(true, EXCERCISE_SAVED, "success");
            } else {
              history.push("/knovo");
              if (!fromCourse) {
                onHeaderItemSelected("home");
                // history.push("/home");
              } else {
                setNavigationIndex(3);
                onHeaderItemSelected("classes");
              }
            }
          }
        }
      }
    }
  }

  function afterSaveResponse(index, isRecord, navType, previous) {
    setSaveUserErrorCount(0);
    const completed = activitySaveType === "SAVE" ? 0 : 1;
    if (completed === 0) {
      if (isContained) {
        closeContained(true);
        setShowHideLoader(false);
      } else {
        if (isRecord) {
          setShowHideLoader(false);
          setDisplayHeader(true);
        } else {
          if (navType === "arrow") {
            if (previous) {
              checkAndNavigatePrevious(previous);
            } else {
              if (exerciseList.length > 0) {
                checkAndNavigatePrevious(previous);
              } else {
                setShowHideLoader(false);
                showOrHideToaster(true, "You are in last activity", "warning");
              }
            }
          } else if (navType === "sideMenu") {
            checkAndNavigate(index);
          } else if (navType === "submit") {
            setShowHideLoader(false);
            setIsActive(false);
          } else if (navType === "close") {
            setDisplayHeader(false);
            if (fromAnalytics) {
              history.push("/detailactivityreport");
            } else {
              if (isContained) {
                setShowHideLoader(false);
                showOrHideToaster(true, EXCERCISE_SAVED, "success");
              } else {
                history.push("/knovo");
                if (!fromCourse) {
                  onHeaderItemSelected("home");
                } else {
                  setNavigationIndex(3);
                  onHeaderItemSelected("classes");
                }
              }
            }
          }
        }

        // if (previous === "record") {
        // } else {
        //   if (navType === "" && resetSave === "reset") {
        //     getActivityForStudent(user.LoginID, ContentID, () => {
        //       history.push("/SmartPaper/".concat(ContentID));
        //       window.location.reload(false);
        //     });
        //   } else {
        //     if (navType === "nav") {
        //       setSmartPaperData({
        //         BackgroundImage: "",
        //         Strokes: [],
        //         StrokeActions: [],
        //         InputRows: [],
        //         ReplayRectangles: [],
        //         TotalScore: 0,
        //         EditorImageHeight: 0,
        //         EditorImageWidth: 0,
        //         ReplayRectanglesAudio: [],
        //         Opacity: "rgba(0,0,0,0)",
        //         TextToSpeech: [],
        //         Seconds: [],
        //         Back: false,
        //         Skip: false,
        //         Stop: false,
        //       });
        //       checkAndNavigatePrevious(previous);
        //     } else if (navType === "hamburger") {
        //       if (fromAnalytics) {
        //         history.push("/detailactivityreport");
        //       } else {
        //         refreshAndNavigateToTableOfContent();
        //       }
        //     } else {
        //       if (index === -1) {
        //         if (fromAnalytics) {
        //           history.push("/detailactivityreport");
        //         } else {
        //           if (!fromCourse) {
        //             history.push("/courses");
        //           } else {
        //             history.push("/lessons/".concat(currentCourseId));
        //           }
        //         }
        //       } else {
        //         setSmartPaperData({
        //           BackgroundImage: "",
        //           Strokes: [],
        //           StrokeActions: [],
        //           InputRows: [],
        //           ReplayRectangles: [],
        //           TotalScore: 0,
        //           EditorImageHeight: 0,
        //           EditorImageWidth: 0,
        //           ReplayRectanglesAudio: [],
        //           Opacity: "rgba(0,0,0,0)",
        //           TextToSpeech: [],
        //           Seconds: [],
        //           Back: false,
        //           Skip: false,
        //           Stop: false,
        //         });
        //         checkAndNavigate(index);
        //       }
        //     }
        //   }
        // }
      }
    } else {
      setActivitySaveClick(false);
      setShowHideLoader(false);
      setIsActive(false);
      showOrHideToaster(true, EXCERCISE_SAVED, "success");
      window.speechSynthesis.cancel();
    }
  }

  function navigateToExercise(contentID, tokenData) {
    window.speechSynthesis.cancel();
    setIsKnovoHelpOpen(false);
    setDisplayKnovoTalk(false);
    setActivitySaveClick(false);
    setIsBgAudioPlayed(false);
    setTimeout(() => {
      getActivityForStudent(
        user.LoginID,
        contentID,
        tokenData,
        (activityDataResponse) => {
          if (activityDataResponse.StatusCode === 200) {
            setTimeout(() => {
              setSaveUserErrorCount(0);
              history.push("/Activity");
            }, 2000);
          } else if (activityDataResponse.StatusCode === 401) {
            if (saveUserErrorCount < 1) {
              refreshTokenCall(GET_ACTIVITY);
            } else {
              setShowHideLoader(false);
              showOrHideToaster(
                true,
                "Server failed! Please try again.",
                "error"
              );
              setSaveUserErrorCount(0);
            }
          } else {
            showOrHideToaster(
              true,
              activityDataResponse.StatusMessage,
              "error"
            );
          }
        }
      );
    }, 1000);
  }

  function refreshTokenCall(apiCall) {
    refreshToken(token, (tokenResponse) => {
      if (tokenResponse.Success) {
        if (apiCall === GET_ACTIVITY) {
          navigateToExercise(selectedContentID, tokenResponse.Token);
        }
        userToken(tokenResponse.Token);
        setSaveUserErrorCount(1);
      } else {
        setShowHideLoader(false);
        showOrHideToaster(true, "Server failed! Please try again.", "error");
        setSaveUserErrorCount(0);
      }
    });
  }

  function checkAndNavigate(index) {
    let exerciseList = [
      ...lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult,
    ];
    const prevEx = exerciseList.slice(0, index + 1);
    const currentExercise = exerciseList[index];
    const { ContentID, AppName } = currentExercise;

    setPreviousExerciseList(prevEx, () => {
      console.log("previous exercise updated");
    });
    setExerciseList(exerciseList.slice(index + 1), () => {
      setSelectedContentID(ContentID);
      navigateToExercise(ContentID, token);
    });
  }

  function checkAndNavigatePrevious(previous) {
    if (previous) {
      let previousExerciseListCopy = [...previousExerciseList];
      if (previousExerciseListCopy.length <= 1) {
        setShowHideLoader(false);
      } else {
        const currentExercise =
          previousExerciseListCopy[previousExerciseListCopy.length - 2];
        const lastExercise =
          previousExerciseListCopy[previousExerciseListCopy.length - 1];
        previousExerciseListCopy.pop();
        const { ContentID, AppName } = currentExercise;
        let exerciseListCopy = [...exerciseList];
        exerciseListCopy.unshift(lastExercise);
        setExerciseList(exerciseListCopy, () => {
          console.log("next exercise updated");
        });
        setPreviousExerciseList(previousExerciseListCopy, () => {
          setSelectedContentID(ContentID);
          navigateToExercise(ContentID, token);
        });
      }
    } else {
      let exerciseListCopy = [...exerciseList];
      if (exerciseListCopy.length > 0) {
        const currentExercise = exerciseListCopy.shift();
        const { ContentID, AppName } = currentExercise;
        let previousExerciseListCopy = [...previousExerciseList];
        previousExerciseListCopy.push(currentExercise);
        setPreviousExerciseList(previousExerciseListCopy, () => {
          console.log("previous exercise updated");
        });
        setExerciseList(exerciseListCopy, () => {
          setSelectedContentID(ContentID);
          navigateToExercise(ContentID, token);
        });
      }
    }
  }

  function renderLoader() {
    return (
      <span
        style={{
          width: "100vw",
          height: "100vh",
          backgroundColor: "#00000080",
          top: 0,
          position: "absolute",
          zIndex: 999,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Loader />
      </span>
    );
  }

  function clearDataWhenReset() {
    setMinutesPractice(0);
    setSecondsPractice(0);
    setShowHideLoader(false);
  }

  const knovoEntranceAnime = {
    loop: true,
    autoplay: true,
    animationData: knovoEntrence,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const knovoTalkingAnime = {
    loop: true,
    autoplay: true,
    animationData: knovoTalk,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const knovoIdleAnime = {
    loop: true,
    autoplay: true,
    animationData: knovoIdle,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const knovoExitAnime = {
    loop: true,
    autoplay: true,
    animationData: knovoExit,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const knovoSuccessAnime = {
    loop: true,
    autoplay: true,
    animationData: knovoPositive,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const knovoFailureAnime = {
    loop: true,
    autoplay: true,
    animationData: knovoNegative,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function renderEntrenceAnime() {
    return (
      <span className="knovaBotView">
        <div className="knovaBotContainer" style={{ zIndex: 7 }}>
          <Lottie
            options={knovoEntranceAnime}
            speed={2}
            width={200}
            isStopped={false}
            style={{
              justifyContent: "center",
              alignSelf: "center",
              height: undefined,
            }}
          />
        </div>
      </span>
    );
  }

  function renderTalkingAnime() {
    return (
      <span className="knovaBotView">
        <div className="knovaBotContainer" style={{ zIndex: 7 }}>
          <Lottie
            options={knovoTalkingAnime}
            width={250}
            isStopped={false}
            style={{
              justifyContent: "center",
              alignSelf: "center",
              height: undefined,
            }}
          />
        </div>
      </span>
    );
  }

  function renderIdleAnime() {
    return (
      <span className="knovaBotView">
        <div
          className="knovaBotContainer"
          style={{ zIndex: 7 }}
          onClick={() => {
            if (recordingStatus) {
              showOrHideToaster(true, RECORD_ONGOING, "warning");
            } else {
              setIsKnovoHelpOpen(true);
            }
          }}
        >
          <Lottie
            options={knovoIdleAnime}
            width={200}
            isStopped={false}
            style={{
              justifyContent: "center",
              alignSelf: "center",
              height: undefined,
            }}
          />
        </div>
      </span>
    );
  }

  function renderExitAnime() {
    return (
      <span className="knovaBotView">
        <div className="knovaBotContainer" style={{ zIndex: 7 }}>
          <Lottie
            options={knovoExitAnime}
            width={200}
            isStopped={false}
            style={{
              justifyContent: "center",
              alignSelf: "center",
              height: undefined,
            }}
          />
        </div>
      </span>
    );
  }

  function renderPositiveAnime() {
    return (
      <span className="knovaBotView">
        <div className="knovaBotContainer" style={{ zIndex: 7 }}>
          <Lottie
            options={knovoSuccessAnime}
            width={200}
            isStopped={false}
            style={{
              justifyContent: "center",
              alignSelf: "center",
              height: undefined,
            }}
          />
        </div>
      </span>
    );
  }

  function renderNegativeAnime() {
    return (
      <span className="knovaBotView">
        <div className="knovaBotContainer" style={{ zIndex: 7 }}>
          <Lottie
            options={knovoFailureAnime}
            width={200}
            isStopped={false}
            style={{
              justifyContent: "center",
              alignSelf: "center",
              height: undefined,
            }}
          />
        </div>
      </span>
    );
  }

  //get canvas width and height
  useEffect(() => {
    var ansContWidth = ansContainerRef.current.clientWidth;
    var ansContHeight = ansContainerRef.current.clientHeight;
    let canvasAreaDimensions = { width: ansContWidth, height: ansContHeight };
    setCanvasAreaDimensions(canvasAreaDimensions);
  }, []);

  useEffect(() => {
    if (resize > 0) {
      var ansContWidth = ansContainerRef.current.clientWidth;
      var ansContHeight = ansContainerRef.current.clientHeight;
      let canvasAreaDimensions = { width: ansContWidth, height: ansContHeight };
      setCanvasAreaDimensions(canvasAreaDimensions);
    }
  }, [resize]);

  useEffect(() => {
    if (displayHeader) {
      var headContWidth = headerContainerRef.current.clientWidth;
      var headContHeight = headerContainerRef.current.clientHeight;
      let headAreaDimensions = { width: headContWidth, height: headContHeight };
      setHeaderAreaDimensions(headAreaDimensions);
    }
  }, [displayHeader]);

  function speakWarningOrSuccess(text) {
    window.speechSynthesis.onvoiceschanged = (event) => {
      console.log("voicesChanged");
    };
    setTimeout(() => {
      setIsWarningBotTalking(true);
      if (currentOSName === "Chrome OS") {
        msg.voiceURI = "Chrome OS US English 8";
        msg.volume = 1;
        msg.rate = 0.8;
        msg.pitch = 0.9;
        msg.text = text;
        msg.lang = "en-US";
        msg.onend = function () {
          setIsWarningBotTalking(false);
        };
        window.speechSynthesis.speak(msg);
      } else {
        msg.voiceURI = "Google US English";
        msg.volume = 1;
        msg.rate = 0.8;
        msg.pitch = 0.9;
        msg.text = text;
        msg.lang = "en-US";
        msg.onend = function () {
          setIsWarningBotTalking(false);
        };
        window.speechSynthesis.speak(msg);
      }
    }, 100);
  }

  //handle succes or failure feedback
  useEffect(() => {
    if (isFeedbackAnime) {
      setTimeout(() => {
        setIsFeedbackAnime(false);
      }, 500);
    }
  }, [isFeedbackAnime]);

  //Chat functions
  function handleChatClarification(clarificationType, clarificationData) {
    // setShowHideLoader(true);
    chatChallengeMe(
      clarificationType,
      clarificationData.topic,
      clarificationData.keyword,
      clarificationData.question_type,
      clarificationData.num_of_options,
      clarificationData.content,
      (response) => {
        setAiChatResponseData(response);
        //  setIsKnovoApiCall(false);
        // setShowHideLoader(false);
      }
    );
  }

  const elementRef = useRef(null);

  useEffect(() => {
    if (!isMinimize) {
      goFullScreen();
    } else {
      if (isBgAudioPlayed) {
        exitFullScreen();
      }
    }
  }, [isMinimize]);

  const goFullScreen = () => {
    const element = document.documentElement; // Entire document fullscreen
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen(); // For Firefox
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen(); // For Chrome, Safari, and Opera
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen(); // For Internet Explorer/Edge
    }
  };

  const exitFullScreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  return (
    <section className="activity-main-screen" ref={elementRef}>
      {hideHeaderValue && <div className="blur-header" />}
      {loading && renderLoader()}
      {/* <button ref={buttonRef}> Self Click </button> */}
      <ActivityMenu
        lessonName={unitName}
        isSideMenuOpen={isSideMenuOpen}
        activityList={
          lessonUnitDetails.Data &&
          lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult
            ? lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult
            : []
        }
        ContentID={ContentID}
        imageFile={Images}
        onLessonClick={() => {}}
        onActivityClick={(index) => {
          setShowHideLoader(true);
          setDisplayKnovoTalk(false);
          window.speechSynthesis.cancel();
          setActivitySaveType("SAVE");
          activityNavigationType.current = "sideMenu";
          arrowNavigationType.current = false;
          sideMenuItemSelected.current = index;
          setTimeout(() => {
            setActivitySaveClick(true);
          }, 1300);
        }}
        onOutsideClick={() => {
          setIsSideMenuOpen(false);
        }}
      />
      {displayHeader &&
        !isVideoPlaying &&
        !isContainedOpen &&
        !isExpandableView &&
        isMinimize && (
          <div
            ref={headerContainerRef}
            className="activity-header-container bounceInDown"
            style={{
              pointerEvents: !tutorTalking || isReplaying ? "none" : "auto",
            }}
          >
            <ActivityHeader
              isPractice={isPractice}
              isContained={isContained}
              isActive={isActive}
              Completed={Completed}
              Status={Status}
              resetValue={getResetDataValue}
              imageFile={Images}
              timerValue={
                isPractice
                  ? getTimeSpent(minutesPractice, secondsPractice, true)
                  : getTimeSpentOverall(minutes, seconds, true)
              }
              activityName={ContentName}
              scoreValue={getActivityCurrentScore}
              totalScoreValue={activityTotalScore}
              displayBurgerIcon={!isContained ? true : false}
              displayWalkThrough={displayWalkThrough}
              currentWalkThroughStep={currentWalkThroughStep}
              hideHeader={hideHeaderValue}
              exerciseList={exerciseList}
              previousExerciseList={previousExerciseList}
              disableClick={disableClick}
              onMenuClick={() => {
                setCurrentActiveSlide("");
                if (recordingStatus) {
                  showOrHideToaster(true, RECORD_ONGOING, "warning");
                } else {
                  if (isBgAudioPlayed) {
                    setIsSideMenuOpen(true);
                    setTimeout(() => {
                      setIsSideMenuOpen(false);
                    }, 5000);
                  }
                }
              }}
              onLeftClick={() => {
                setCurrentActiveSlide("");
                if (recordingStatus) {
                  showOrHideToaster(true, RECORD_ONGOING, "warning");
                } else {
                  if (isBgAudioPlayed) {
                    if (
                      lessonUnitDetails.Data
                        .GetLessonUnitDetailsForAStudentResult.length -
                        1 ===
                      exerciseList.length
                    ) {
                      setShowHideLoader(false);
                      showOrHideToaster(
                        true,
                        "You are in first activity",
                        "warning"
                      );
                    } else {
                      setShowHideLoader(true);
                      setDisplayKnovoTalk(false);
                      window.speechSynthesis.cancel();
                      setActivitySaveType("SAVE");
                      activityNavigationType.current = "arrow";
                      arrowNavigationType.current = true;
                      setTimeout(() => {
                        setActivitySaveClick(true);
                      }, 1300);
                    }
                  }
                }
              }}
              onRightClick={() => {
                setCurrentActiveSlide("");
                if (recordingStatus) {
                  showOrHideToaster(true, RECORD_ONGOING, "warning");
                } else {
                  if (isBgAudioPlayed) {
                    if (exerciseList.length > 0) {
                      setShowHideLoader(true);
                      setDisplayKnovoTalk(false);
                      window.speechSynthesis.cancel();
                      setActivitySaveType("SAVE");
                      activityNavigationType.current = "arrow";
                      arrowNavigationType.current = false;
                      setTimeout(() => {
                        setActivitySaveClick(true);
                      }, 1300);
                    } else {
                      setShowHideLoader(false);
                      showOrHideToaster(
                        true,
                        "You are in last activity",
                        "warning"
                      );
                    }
                  }
                }
              }}
              onResetClick={(resetType) => {
                if (recordingStatus) {
                  showOrHideToaster(true, RECORD_ONGOING, "warning");
                } else {
                  if (isBgAudioPlayed) {
                    if (Completed === 0 && isActive) {
                      if (resetType === "resetTest") {
                        setPopupType("resetTest");
                      } else if (resetType === "resetPractice") {
                        setPopupType("resetPractice");
                      }
                      setConfirmPopupVisible(true);
                    }
                  }
                }
              }}
              onDoneClick={() => {
                if (recordingStatus) {
                  showOrHideToaster(true, RECORD_ONGOING, "warning");
                } else {
                  if (isBgAudioPlayed) {
                    if (isContained) {
                      if (Completed === 0 && isActive) {
                        setShowHideLoader(true);
                        setActivitySaveClick(true);
                        window.speechSynthesis.cancel();
                        setActivitySaveType("SAVE");
                        activityNavigationType.current = "arrow";
                      }
                    } else {
                      if (Completed === 0) {
                        setPopupType("submit");
                        setConfirmPopupVisible(true);
                      }
                    }
                  }
                }
              }}
              onCloseClick={() => {
                if (recordingStatus) {
                  showOrHideToaster(true, RECORD_ONGOING, "warning");
                } else {
                  if (isBgAudioPlayed) {
                    setDisplayKnovoExit(true);
                    setDisplayKnovoTalk(false);
                    window.speechSynthesis.cancel();
                    setActivitySaveType("SAVE");
                    activityNavigationType.current = "close";
                    setTimeout(() => {
                      setShowHideLoader(true);
                      setDisplayKnovoExit(false);
                      if (Completed === 0 && isActive) {
                        setActivitySaveClick(true);
                      } else {
                        setIsBgAudioPlayed(false);
                        if (isContained) {
                          closeContained(true);
                        } else {
                          if (fromAnalytics) {
                            history.push("/detailactivityreport");
                          } else {
                            history.push("/knovo");
                            if (!fromCourse) {
                              onHeaderItemSelected("home");
                            } else {
                              setNavigationIndex(3);
                              onHeaderItemSelected("classes");
                            }
                          }
                        }
                      }
                    }, 1000);
                  }
                }
              }}
              isGuidedActivity={isGuidedActivity}
              handleBotVolume={(isBotClicked) => {
                if (isBotClicked) {
                  if (muteStatus) {
                    saveMuteStatus(false, true);
                  } else {
                    saveMuteStatus(true, true);
                  }
                } else {
                  saveMuteStatus(muteStatus, false);
                }
              }}
              muteStatus={muteStatus}
            />
          </div>
        )}
      <div
        className="activity-canvas-container"
        id="answerContainerDiv"
        ref={ansContainerRef}
        style={{
          height:
            isVideoPlaying || isContainedOpen || isExpandableView || !isMinimize
              ? "100%"
              : "94%",
        }}
      >
        <WalkThroughIntro
          popupVisible={displayWalkThrough}
          walkThroughManual={walkThroughManual}
          currentOSName={currentOSName}
          getCurrentWalkThroughStep={(currentWalkThroughStep) => {
            setCurrentWalkThroughStep(currentWalkThroughStep);
          }}
          onTourComplete={() => {
            startActivity();
          }}
        />
        <TeacherFeedback
          feedbackVisible={feedbackVisible}
          Feedback={Feedback}
          onPopupCancel={() => {
            setFeedbackVisible(false);
          }}
          // teacherRecording={
          //   currentRecordedTeacherURL.current
          //     ? currentRecordedTeacherURL.current
          //     : undefined
          // }
          // isTeacherRecordPlaying={isTeacherRecordPlaying}
          // setIsTeacherRecordPlaying={(teacherRecordStatus) => {
          //   setIsTeacherRecordPlaying(teacherRecordStatus);
          // }}
        />
        {/* <div
          className="blur-component"
          style={{
            width: "100%",
            height: "90%",
            position: "absolute",
            bottom: 0,
            zIndex: 6,
          }}
        ></div> */}
        {/* SmartTileScreen */}
        {AppName && AppName === SMART_TILE ? (
          <SmartTileMainScreen
            user={user}
            currentLessonUnitDistId={currentLessonUnitDistId}
            activityDataFromParent={
              isContained ? containedActivity : currentActivity
            }
            isActive={isActive}
            Completed={Completed}
            minutes={minutes}
            seconds={seconds}
            minutesPractice={minutesPractice}
            secondsPractice={secondsPractice}
            isContained={isContained}
            tutorialStart={tutorialStart}
            activitySaveClick={activitySaveClick}
            activitySaveType={activitySaveType}
            isBgAudioPlayed={isBgAudioPlayed}
            activityResetType={activityResetType}
            getStudentWorkedDataFromChild={(studentWorkedData) => {
              saveDataAndNavigate(
                studentWorkedData,
                activityNavigationType.current,
                arrowNavigationType.current,
                sideMenuItemSelected.current,
                false,
                token
              );
            }}
            getStudentCurrentScore={(currentScore) => {
              setGetActivityCurrentScore(currentScore);
            }}
            getStudentCurrentScoreApi={(currentScoreApi) => {}}
            getTutorTalking={(tutorTalking) => {
              setTutorTalking(tutorTalking);
            }}
            getActivityResetStatus={() => {
              setPopupType("");
              setActivityResetType("");
              setConfirmPopupVisible(false);
              clearDataWhenReset();
            }}
            isKnovoHelpOpen={isKnovoHelpOpen}
            knovoHelpClose={() => {
              setIsKnovoHelpOpen(false);
            }}
            getValidationFeedback={(feedbackType, status) => {
              setValidationFeedback(feedbackType);
              setIsFeedbackAnime(status);
            }}
            getActivityLoaded={(status) => {
              setDisableClick(status);
            }}
            showOrHideToaster={(status, message, type) => {
              showOrHideToaster(status, message, type);
            }}
          />
        ) : AppName === SMART_LABEL ? (
          <SmartLabelParentScreen
            user={user}
            currentLessonUnitDistId={currentLessonUnitDistId}
            activityDataFromParent={
              isContained ? containedActivity : currentActivity
            }
            isActive={isActive}
            Completed={Completed}
            minutes={minutes}
            seconds={seconds}
            minutesPractice={minutesPractice}
            secondsPractice={secondsPractice}
            isContained={isContained}
            tutorialStart={tutorialStart}
            activitySaveClick={activitySaveClick}
            activitySaveType={activitySaveType}
            isBgAudioPlayed={isBgAudioPlayed}
            getStudentWorkedDataFromChild={(studentWorkedData) => {
              saveDataAndNavigate(
                studentWorkedData,
                activityNavigationType.current,
                arrowNavigationType.current,
                sideMenuItemSelected.current,
                false,
                token
              );

              // console.log("studentWorkedData", studentWorkedData);
            }}
            getStudentCurrentScore={(currentScore) => {
              setGetActivityCurrentScore(currentScore);
            }}
            getStudentCurrentScoreApi={(currentScoreApi) => {}}
            getTutorTalking={(tutorTalking) => {
              setTutorTalking(tutorTalking);
            }}
            canvasAreaDimensions={canvasAreaDimensions}
            activityResetType={activityResetType}
            getActivityResetStatus={() => {
              setPopupType("");
              setActivityResetType("");
              setConfirmPopupVisible(false);
            }}
            getScreenName={(screen, modesWork) => {
              setModesWorkData(modesWork);
              setScreenName(screen);
            }}
            isKnovoHelpOpen={isKnovoHelpOpen}
            knovoHelpClose={() => {
              setIsKnovoHelpOpen(false);
            }}
            getValidationFeedback={(feedbackType, status) => {
              setValidationFeedback(feedbackType);
              setIsFeedbackAnime(status);
            }}
            getActivityLoaded={(status) => {
              setDisableClick(status);
            }}
            showOrHideToaster={(status, message, type) => {
              showOrHideToaster(status, message, type);
            }}
            //Toast variable
            onToastTrigger={(toastMessage) => {
              showOrHideToaster(true, toastMessage, "warning");
            }}
          />
        ) : AppName === SMART_SLIDE ? (
          // SmartSlideScreen
          <SmartSlideMainScreen
            user={user}
            currentLessonUnitDistId={currentLessonUnitDistId}
            activityDataFromParent={
              isContained ? containedActivity : currentActivity
            }
            isActive={isActive}
            minutes={minutes}
            seconds={seconds}
            minutesPractice={minutesPractice}
            secondsPractice={secondsPractice}
            isContained={isContained}
            tutorialStart={tutorialStart}
            activitySaveClick={activitySaveClick}
            activitySaveType={activitySaveType}
            isBgAudioPlayed={isBgAudioPlayed}
            activityResetType={activityResetType}
            getStudentWorkedDataFromChild={(studentWorkedData) => {
              saveDataAndNavigate(
                studentWorkedData,
                activityNavigationType.current,
                arrowNavigationType.current,
                sideMenuItemSelected.current,
                false,
                token
              );

              // console.log("studentWorkedData", studentWorkedData);
            }}
            getStudentCurrentScore={(currentScore) => {
              setGetActivityCurrentScore(currentScore);
            }}
            getStudentCurrentScoreApi={(currentScoreApi) => {}}
            getCurrentSlideIndex={(currentSlideIndex) => {
              // window.speechSynthesis.cancel();
              setCurrentActiveSlide(currentSlideIndex);
            }}
            getActivityResetStatus={() => {
              setPopupType("");
              setActivityResetType("");
              setConfirmPopupVisible(false);
              clearDataWhenReset();
            }}
            getTutorTalking={(tutorTalking) => {
              setTutorTalking(tutorTalking);
            }}
            canvasAreaDimensions={canvasAreaDimensions}
            isKnovoHelpOpen={isKnovoHelpOpen}
            knovoHelpClose={() => {
              setIsKnovoHelpOpen(false);
            }}
            getValidationFeedback={(feedbackType, status) => {
              setValidationFeedback(feedbackType);
              setIsFeedbackAnime(status);
            }}
            getActivityLoaded={(status) => {
              setDisableClick(status);
            }}
            showOrHideToaster={(status, message, type) => {
              showOrHideToaster(status, message, type);
            }}
          />
        ) : AppName === "SmartPaper" && IsCanvas ? (
          <SmartCanvasBaseScreen
            activityDataFromParent={
              isContained ? containedActivity : currentActivity
            }
            currentLessonUnitDistId={currentLessonUnitDistId}
            user={user}
            isBgAudioPlayed={isBgAudioPlayed}
            Completed={Completed}
            isActive={isActive}
            minutes={minutes}
            seconds={seconds}
            canvasAreaDimensions={canvasAreaDimensions}
            isCanvas={IsCanvas}
            activitySaveClick={activitySaveClick}
            activitySaveType={activitySaveType}
            isMinimize={isMinimize}
            getActivityLoaded={(status) => {
              setDisableClick(status);
            }}
            getStudentCurrentScore={(currentScore) => {
              setGetActivityCurrentScore(currentScore);
            }}
            knovoHelpClose={() => {
              setIsKnovoHelpOpen(false);
            }}
            getTemplatesData={() => {}}
            getStudentWorkedDataFromChild={(studentWorkedData, isRecord) => {
              saveDataAndNavigate(
                studentWorkedData,
                activityNavigationType.current,
                arrowNavigationType.current,
                sideMenuItemSelected.current,
                isRecord,
                token
              );

              // console.log("studentWorkedData", studentWorkedData);
            }}
            getTutorTalking={(tutorTalking) => {
              setTutorTalking(tutorTalking);
            }}
            getFullscreen={(fullScreen) => {
              setIsMinimize(fullScreen);
            }}
            //AI Chat bot variables
            updatedAIResponse={aiChatResponseData}
            handleChatClarification={handleChatClarification}
            //Toast variable
            onToastTrigger={(toastMessage) => {
              showOrHideToaster(true, toastMessage, "warning");
            }}
            getRecordingStatus={(recordingStatus) => {
              setIsRecordingStatus(recordingStatus);
            }}
            getCurrentActivePage={(activePage) => {
              setCurrentActivePage(activePage);
            }}
            currentOSName={currentOSName}
            isActivitySideMenuOpen={isSideMenuOpen}
            activityResetType={isReset}
            getStrokeReplaying={(replayStatus) => {
              setIsReplaying(replayStatus);
            }}
            getExtraPracticeStatus={(extraPracticeStatus) => {
              setIsExtraPracticeVisible(extraPracticeStatus);
            }}
          />
        ) : (
          // <SmartPaperParentScreen
          //   canvasAreaDimensions={canvasAreaDimensions}
          //   activityDataFromParent={
          //     isContained ? containedActivity : currentActivity
          //   }
          //   isBgAudioPlayed={isBgAudioPlayed}
          //   isActive={isActive}
          //   minutes={minutes}
          //   seconds={seconds}
          //   minutesPractice={minutesPractice}
          //   secondsPractice={secondsPractice}
          //   getActivityLoaded={(status) => {
          //     setDisableClick(status);
          //   }}
          //   getTutorTalking={(tutorTalking) => {
          //     setTutorTalking(tutorTalking);
          //   }}
          //   knovoHelpClose={() => {
          //     setIsKnovoHelpOpen(false);
          //   }}
          // ></SmartPaperParentScreen>

          <SmartPaperScreen
            activityDataFromParent={
              isContained ? containedActivity : currentActivity
            }
            isContained={isContained}
            isActive={isActive}
            minutes={minutes}
            seconds={seconds}
            minutesPractice={minutesPractice}
            secondsPractice={secondsPractice}
            tutorialStart={tutorialStart}
            activitySaveClick={activitySaveClick}
            activitySaveType={activitySaveType}
            isBgAudioPlayed={isBgAudioPlayed}
            activityResetType={activityResetType}
            canvasAreaDimensions={canvasAreaDimensions}
            displayWalkThrough={displayWalkThrough}
            currentWalkThroughStep={currentWalkThroughStep}
            confirmPopupVisible={confirmPopupVisible}
            getStudentWorkedDataFromChild={(studentWorkedData, isRecord) => {
              saveDataAndNavigate(
                studentWorkedData,
                activityNavigationType.current,
                arrowNavigationType.current,
                sideMenuItemSelected.current,
                isRecord,
                token
              );
            }}
            getStudentCurrentScore={(currentScore) => {
              setGetActivityCurrentScore(currentScore);
            }}
            getStudentCurrentScoreApi={(currentScoreApi) => {}}
            getActivityResetStatus={() => {
              setPopupType("");
              setActivityResetType("");
              setConfirmPopupVisible(false);
              clearDataWhenReset();
            }}
            recordPopupClick={recordPopupClick}
            getRecordAction={(actionType) => {
              setRecordPopupClick(-1);
              if (actionType === "save") {
                setPopupType("recordSave");
                setConfirmPopupVisible(true);
              } else {
                setPopupType("recordDelete");
                setConfirmPopupVisible(true);
              }
            }}
            isHardReset={isHardReset}
            hardResetDone={() => {
              setIsHardReset(false);
            }}
            getTutorTalking={(tutorTalking) => {
              setTutorTalking(tutorTalking);
            }}
            isKnovoHelpOpen={isKnovoHelpOpen}
            knovoHelpClose={() => {
              setIsKnovoHelpOpen(false);
            }}
            knovoActivityTourClick={() => {
              setWalkThroughManual(true);
              setDisplayWalkThrough(true);
            }}
            onActivitySubmitClick={() => {
              if (Completed === 0) {
                setActivitySaveType("SUBMIT");
                activityNavigationType.current = "submit";
                setActivitySaveClick(true);
                setPopupType("");
                setConfirmPopupVisible(false);
              }
            }}
            isWarningBotTalking={isWarningBotTalking}
            onWarningBotDialog={(message) => {
              if (message === "") {
              } else {
                speakWarningOrSuccess(message);
              }
            }}
            onHideHeader={(status) => {
              sethideHeaderValue(status);
            }}
            getRecordingStatus={(recordingStatus) => {
              setIsRecordingStatus(recordingStatus);
            }}
            getIsVideoPlaying={(videoStatus) => {
              setIsVideoPlaying(videoStatus);
            }}
            getIsContainedOpen={(containedStatus) => {
              setIsContainedOpen(containedStatus);
            }}
            getValidationFeedback={(feedbackType, status) => {
              setValidationFeedback(feedbackType);
              setIsFeedbackAnime(status);
            }}
            getActivityLoaded={(status) => {
              setDisableClick(status);
            }}
            getIsExpandableView={(expandViewStatus) => {
              setIsExpandableView(expandViewStatus);
            }}
            //GuidedClosehandle
            onGuidedCloseClick={() => {
              if (recordingStatus) {
                showOrHideToaster(true, RECORD_ONGOING, "warning");
              } else {
                if (isBgAudioPlayed) {
                  setDisplayKnovoExit(true);
                  setDisplayKnovoTalk(false);
                  window.speechSynthesis.cancel();
                  setActivitySaveType("SAVE");
                  activityNavigationType.current = "close";
                  setTimeout(() => {
                    setShowHideLoader(true);
                    setDisplayKnovoExit(false);
                    if (Completed === 0 && isActive) {
                      setActivitySaveClick(true);
                    } else {
                      setIsBgAudioPlayed(false);
                      if (isContained) {
                        closeContained(true);
                      }
                    }
                  }, 1000);
                }
              }
            }}
            handleGuidedActivity={(isGuidedActivity) => {
              //  console.log("handleGuidedActivity", isGuidedActivity);
              setIsGuidedActivity(isGuidedActivity);
            }}
          />
        )}
      </div>
      {displayKnovoEntrence &&
        !displayKnovoExit &&
        !displayWalkThrough &&
        !isFeedbackAnime &&
        renderEntrenceAnime()}
      {displayKnovoTalk &&
        !displayKnovoExit &&
        !tutorTalking &&
        !displayWalkThrough &&
        renderTalkingAnime()}
      {/* {displayKnovoTalk && !tutorTalking && renderTalkingAnime()} */}
      {isBgAudioPlayed &&
        !displayKnovoEntrence &&
        displayKnovoTalk &&
        !displayKnovoExit &&
        tutorTalking &&
        !displayWalkThrough &&
        !isVideoPlaying &&
        !isContainedOpen &&
        !isFeedbackAnime &&
        renderIdleAnime()}
      {displayKnovoExit && !displayWalkThrough && renderExitAnime()}
      {isFeedbackAnime &&
        validationFeedback === "success" &&
        !displayKnovoExit &&
        renderPositiveAnime()}
      {isFeedbackAnime &&
        validationFeedback === "failure" &&
        !displayKnovoExit &&
        renderNegativeAnime()}
      {!loading && walkthroughStatus && (
        <Tutor
          // speechApi={speechApi}
          newlyOpenedActivity={newlyOpenedActivity}
          ttsData={ttsData}
          tutorialStart={tutorialStart}
          onTutorialComplete={() => {
            setTutorialStart(false);
            setIsBgAudioPlayed(true);
          }}
          showCC={isSubtitle}
          getTutorTalking={(tutorTalking) => {
            setTutorTalking(tutorTalking);
          }}
          currentOSName={currentOSName}
          muteStatus={muteStatus}
          proceedClicked={() => {
            setNewlyOpenedActivity(false);
          }}
        />
      )}
      <ToastBox />
      <ConfirmPopup
        popupType={popupType}
        popupVisible={confirmPopupVisible}
        popupText={
          popupType === "submit"
            ? DONE_CONFIRMATION
            : popupType === "reset" || popupType === "resetPractice"
            ? RESET_CONFIRMATION
            : popupType === "recordSave"
            ? RECORD_CONFIRMATION
            : RECORD_DELETE
        }
        onPopupCancel={() => {
          setPopupType("");
          setConfirmPopupVisible(false);
          if (popupType === "recordSave") {
            setRecordPopupClick("saveCancel");
          } else if (popupType === "recordDelete") {
            setRecordPopupClick("deleteCancel");
          }
        }}
        onPopupOk={() => {
          if (popupType === "submit") {
            setShowHideLoader(true);
            activityNavigationType.current = "submit";
            setActivitySaveClick(true);
            setActivitySaveType("SUBMIT");
            setPopupType("");
            setConfirmPopupVisible(false);
          } else if (popupType === "reset" || popupType === "resetPractice") {
            setConfirmPopupVisible(false);
            setActivityResetType(popupType);
            setIsReset(true);
            setTimeout(() => {
              setIsReset(false);
            }, 200);
          } else if (popupType === "recordSave") {
            setShowHideLoader(true);
            setPopupType("");
            setConfirmPopupVisible(false);
            setRecordPopupClick("recordSave");
          } else if (popupType === "recordDelete") {
            setShowHideLoader(true);
            setPopupType("");
            setConfirmPopupVisible(false);
            setRecordPopupClick("recordDelete");
          }
        }}
      />
      {/*

      <TeacherFeedback
        feedbackVisible={feedbackVisible}
        Feedback={Feedback}
        onPopupCancel={() => {
          setFeedbackVisible(false);
        }}
      />
      <AnswerExplanation
        explanationVisible={explanationVisible}
        explanationStatus={explanationStatus}
        explanationText={explanationText}
        onExplanationClosed={() => {
          setExplanationVisible(false);
        }}
      /> */}
    </section>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  lessonUnitDetails: state.user.lessonUnitDetails,
  loading: state.user.loading,
  currentActivity: state.user.currentActivity,
  currentLessonUnitDistId: state.user.currentLessonUnitDistId,
  WorkJson: state.user.WorkJson,
  exerciseList: state.user.exerciseList,
  unitName: state.user.unitName,
  previousExerciseList: state.user.previousExerciseList,
  containedActivity: state.user.containedActivity,
  fromCourse: state.user.fromCourse,
  fromAnalytics: state.user.fromAnalytics,
  currentCourseId: state.user.currentCourseId,
  hardResetRandom: state.user.hardResetRandom,
  currentOSName: state.user.currentOSName,
  walkthroughStatus: state.user.walkthroughStatus,
  muteStatus: state.user.muteStatus,
  muteClicked: state.user.muteClicked,
  speechApi: state.user.speechApi,
});

const mapDispatchToProps = (dispatch) => ({
  setHeaderTitle: (headerTitle) =>
    dispatch(UserActions.setHeaderTitle(headerTitle)),
  setShowHideLoader: (status) =>
    dispatch(UserActions.setShowHideLoader(status)),
  saveActivityForStudent: (token, activity, successFn) =>
    dispatch(UserActions.saveActivityForStudent(token, activity, successFn)),
  refreshToken: (tokenData, successFn) =>
    dispatch(UserActions.refreshToken(tokenData, successFn)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
  setContainedWorkJson: (containedWorkJson) =>
    dispatch(UserActions.setContainedWorkJson(containedWorkJson)),
  setExerciseList: (exerciseList, successFn) =>
    dispatch(UserActions.setExerciseList(exerciseList, successFn)),
  getActivityForStudent: (studentID, contentID, token, successFn) =>
    dispatch(
      UserActions.getActivityForStudent(studentID, contentID, token, successFn)
    ),
  setPreviousExerciseList: (exerciseList, successFn) =>
    dispatch(UserActions.setPreviousExerciseList(exerciseList, successFn)),
  getLessonUnitDetailsForStudent: (studentId, lessonUnitDistId, successFn) =>
    dispatch(
      UserActions.getLessonUnitDetailsForStudent(
        studentId,
        lessonUnitDistId,
        successFn
      )
    ),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
  hardResetRandomActivity: (hardResetRandom) =>
    dispatch(UserActions.hardResetRandomActivity(hardResetRandom)),
  saveWalkthroughStatus: (walkthroughStatus) =>
    dispatch(UserActions.saveWalkthroughStatus(walkthroughStatus)),
  onHeaderItemSelected: (headerItemSelected) =>
    dispatch(UserActions.onHeaderItemSelected(headerItemSelected)),
  setNavigationIndex: (navigationIndex) =>
    dispatch(UserActions.setNavigationIndex(navigationIndex)),
  saveMuteStatus: (muteStatus, muteClicked) =>
    dispatch(UserActions.saveMuteStatus(muteStatus, muteClicked)),
  chatChallengeMe: (
    serviceTypeName,
    topic,
    keyword,
    question_type,
    num_of_options,
    content,
    successFn,
    failureFn
  ) =>
    dispatch(
      UserActions.chatChallengeMe(
        serviceTypeName,
        topic,
        keyword,
        question_type,
        num_of_options,
        content,
        successFn,
        failureFn
      )
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KnovoActivityScreen);
